import * as THREE from 'three'
import { const_var, params } from '../../../redux/reducers/reducer'
import { controls } from '../../../redux/reducers/common/eventReducer' 
import { createSidingInnerTexture, createSidingTextureObject, textureAppliedFor } from '../../../redux/reducers/utils'
import { useMemo } from 'react';
import { useThree } from '@react-three/fiber';

const includesTexture = ["stone", "brick", "real_tree", "camo"]

export const MaterialOuterRoof = ({ texture, isPattern, visibleSection }) => (
    <meshStandardMaterial
        onUpdate={(self) => {self.needsUpdate = true}} 
        map={(isPattern) ? null : texture} 
        color={params.p_r_c.replace("0x","#")}
        side={THREE.DoubleSide}
        roughness={1}
        metalness={0.35}
        toneMapped={false}
        emissive={(isPattern) ? '#000000' : '#101010'}
        transparent={params.is_translusant || (controls.isCheckActiveTab === "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
        needsUpdate={true}
    />
)

export const MaterialInnerRoof = ({ texture, visibleSection }) => (
    <meshBasicMaterial
        onUpdate={(self) => {self.needsUpdate = true}} 
        map={texture}
        side={THREE.DoubleSide}
        color={"#C9C9C9"}
        // color={"#CFCFCF"}
        transparent={params.is_translusant || (controls.isCheckActiveTab === "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
        needsUpdate={true}
    />
)

export const MaterialRoofRidge = ({ isPattern, visibleSection }) => (
    <meshStandardMaterial
        color={params.p_r_c.replace("0x","#")}
        side={THREE.DoubleSide}
        roughness={1}
        metalness={0.35}
        toneMapped={false}
        emissive={(isPattern) ? '#000000' : '#101010'}
        transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
        needsUpdate={true}
    />
)

export const MaterialInnerWall = ({ visibleSection }) => {
    const { gl } = useThree();
    const texture = useMemo(() => createSidingInnerTexture(gl), [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture], params.wallOrientation]);
    return <meshBasicMaterial
        onUpdate={(self) => {self.needsUpdate = true}} 
        map={texture}  
        side={THREE.DoubleSide}
        color={"#C9C9C9"}
        transparent={params.is_translusant || (controls.isCheckActiveTab === "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
    />
}

export const MaterialTrim = ({ visibleSection }) => (
    <meshStandardMaterial
        color={params.p_t_c.replace("0x","#")}
        side={THREE.DoubleSide}
        roughness={0.5}
        metalness={0.2}
        toneMapped={false}
        emissive={'#101010'}
        transparent={params.is_translusant || (controls.isCheckActiveTab === "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
        needsUpdate={true}
    />
)

export const MaterialTruss = ({ normalMap, envMap }) => (
    <meshPhongMaterial
        color={"#F0F0F0"}
        map={normalMap}
        envMap={envMap}
        side={THREE.DoubleSide}
        reflectivity={0.4}
    />
)

export const MaterialHighlightTruss = () => (
    <meshBasicMaterial
        depthTest={false}
        color={'#900000'}
        opacity={0.7}
        transparent
    />
)

export const MaterialOuterWallNew = ({ isPattern, visibleSection }) => {

    const textureObject = useMemo(() => createSidingTextureObject(), [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    return <meshStandardMaterial
        onUpdate={(self) => {self.needsUpdate = true}}
        map={(isPattern && params.wallTexture === "none") ? null : textureObject?.texture}
        aoMap={textureAppliedFor(textureObject?.metalTexture, "wall")}
        aoMapIntensity={1.2}
        lightMap={textureAppliedFor(textureObject?.lightTexture, "wall")}
        lightMapIntensity={3}
        color={params.p_w_c.replace("0x","#")}
        side={THREE.DoubleSide}
        roughness={0.5}
        metalness={(params.p_v_w || params.wallTexture !== "none") ? 0 : 0.2}
        toneMapped={false}
        emissive={'#101010'}
        transparent={params.is_translusant || (controls.isCheckActiveTab === "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
        needsUpdate={true}
    />
}

export const MaterialWainScotWallNew = ({ isPattern, type, visibleSection }) => {

    const textureObject = useMemo(() => createSidingTextureObject(), [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    return <meshStandardMaterial
        onUpdate={(self) => {self.needsUpdate = true}}
        map={(isPattern && params.wainscotTexture === "none") ? null : textureObject?.wainscotTexture}
        aoMap={textureAppliedFor(textureObject?.metalTexture,"wainscot")}
        aoMapIntensity={1.2}
        lightMap={textureAppliedFor(textureObject?.lightTexture,"wainscot")}
        lightMapIntensity={3}
        color={params.p_w_c_c.replace("0x","#")}
        side={THREE.DoubleSide}
        roughness={0.5}
        metalness={(params.p_v_w || params.wainscotTexture !== "none") ? 0 : 0.2}
        toneMapped={false}
        emissive={'#101010'}
        transparent={params.is_translusant || (controls.isCheckActiveTab === "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
        needsUpdate={true}
    />
}

export const MaterialWainScotTrimNew = ({ visibleSection }) => {

    const textureObject = useMemo(() => createSidingTextureObject(), [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    return <meshStandardMaterial
        onUpdate={(self) => {self.needsUpdate = true}}
        map={includesTexture.some(t => params.wainscotTexture.includes(t)) ? textureObject.wainscotTexture : null} 
        color={params.p_w_c_c.replace("0x","#")}
        side={THREE.DoubleSide}
        roughness={0.5}
        metalness={params.p_v_w ? 0.05 : 0.2}
        toneMapped={false}
        emissive={'#101010'}
        transparent={params.is_translusant || (controls.isCheckActiveTab === "doorwindow" && const_var.focusedSection !== visibleSection)}
        opacity={0.02}
    />
}